var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 3.46c0-.68.5-1.4 1.15-1.59 0 0 2.25-.87 5.65-.87 3.4 0 5.65.87 5.65.87.64.2 1.15.91 1.15 1.59v7.8c0 .68-.44 1.55-.98 1.94l-4.84 3.5c-.54.4-1.42.4-1.96 0l-4.84-3.5A2.69 2.69 0 0 1 1 11.26v-7.8Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.4 6 7 10 5 8.18",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgShield;